/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import upArrow from '../chevron-up.svg'
import downArrow from '../chevron-down.svg'

import { Option } from './Option'
import styles from './Selector.module.scss'

function Selector({ iconSrc, title, options, selected, enabledOptions, onChange }) {
    const selectedAll = selected === true

    const [dropped, setDropped] = useState(false)

    const toggleDrop = useCallback(() => {
        setDropped(!dropped)
    }, [dropped, setDropped])

    const onChangeHandler = useCallback((e) => {
        const { name, checked } = e.target

        if (name && name !== 'Все') {
            if (selected === true) {
                onChange(options.filter(option => option !== name))
            } else if (selected.includes(name)) {
                onChange(selected.filter(option => option !== name))
            } else {
                const newSelected = [...selected, name]

                onChange(newSelected.length === options.length ? true : newSelected)
            }
        } else {
            onChange(checked ? true : [])
        }
    }, [selected, options, onChange])

    const enabledOptionsFinal = useMemo(() => {
        if (!dropped) {
            return []
        }

        if (!enabledOptions) {
            return options
        }

        return options.filter(option => enabledOptions.includes(option))
    }, [dropped, options, enabledOptions])

    const disabledOptionsFinal = useMemo(() => {
        if (!dropped) {
            return []
        }

        if (!enabledOptions) {
            return []
        }

        return options.filter(option => !enabledOptions.includes(option))
    }, [dropped, options, enabledOptions])

    return (
        <div className={styles.wrapper}>
            <div className={styles.header} onClick={toggleDrop}>
                <img src={iconSrc} alt="" className={styles.icon} />
                <div>
                    {title}
                </div>
                <div className={classnames({ [styles.applyedFilterCount]: !selectedAll })}>
                    {selectedAll ? '' : `${selected.length}`}
                </div>
                <div className={styles.toggle}>
                    <img src={dropped ? upArrow : downArrow} alt={dropped ? 'Свернуть' : 'Развернуть'} />
                </div>
            </div>
            <div>
                {
                    dropped && (
                        <Option
                            option="Все"
                            enabled
                            selected={selectedAll}
                            onChange={onChangeHandler}
                        />
                    )
                }
                {
                    enabledOptionsFinal.map(option => (
                        <Option
                            key={option}
                            option={option}
                            enabled
                            selected={selectedAll || selected.includes(option)}
                            onChange={onChangeHandler}
                        />
                    ))
                }
                {
                    disabledOptionsFinal.map(option => (
                        <Option
                            key={option}
                            option={option}
                            enabled={false}
                            selected={selectedAll || selected.includes(option)}
                            onChange={onChangeHandler}
                        />
                    ))
                }
            </div>
        </div>
    )
}

Selector.propTypes = {
    iconSrc: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.string),
    selected: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.oneOf([true]),
    ]),
    enabledOptions: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
}

export { Selector }
